export default "__VITE_ASSET__ZIbfRfxT__"